import React from 'react'
import { 
	connect as formikConnect, 
	FieldArray 
} from 'formik'
import { 
	FieldGroup, 
	fieldPresets,
	fieldPreset,
} from '@modules/form/form.module'
import objectPath from 'object-path'
import { CandidateModel } from '@modules/user/user.module'

const dateFormatLabel = '(dd/mm/yyyy)';

@formikConnect
class EmploymentHistoryField extends React.Component {
	
	render() {
		const { name, formik, isEditing } = this.props;
		const values = formik.values[this.props.name];
	  return (
	  	<FieldArray name={name} render={arrayHelpers => (
	  		<div className="EmploymentHistory">
	  		{	
					values.map((v, i) => this.renderEmploymentHistoryItem(i, i ? arrayHelpers.remove : undefined))
				}
				{
					isEditing && 
					<button 
						type="button" 
						className="btn btn-primary" 
						onClick={() => arrayHelpers.push(
							CandidateModel.field('employmentHistory').getChildDefaults()
						)}
					>Add another employer</button>
				}
				</div>
	  	)} />
	  )
	}

	renderEmploymentHistoryItem(index, remove) {
		const { name, isEditing, formik } = this.props;
		const prefix = `${name}.${index}`;
		var datesWorked = objectPath.get(formik.values, `${prefix}.datesWorked`);
		datesWorked = typeof datesWorked === 'object' ? datesWorked : {};

		const positionDetailFields = fieldPresets([
			['companyName', { prefix }],
			['position', { prefix }],
			['datesWorked.from', {
				prefix,
				maxDate: datesWorked.to ? new Date(datesWorked.to) : new Date(),
			}],
			['datesWorked.to', {
				prefix,
				minDate: datesWorked.from ? new Date(datesWorked.from) : null,
				maxDate: new Date(),
			}],
			['duties', { prefix }],
			['reasonsForLeaving', { prefix }],
		]);

		const companyAddressFields = fieldPresets([
			['companyAddress.line1', { prefix }],
			['companyAddress.line2', { prefix }],
			['companyAddress.townCity', { prefix }],
			['companyAddress.country', { prefix }],
			['companyAddress.postCode', { prefix }],
		]);

		const refereeFields = fieldPresets([
			['referee.name', { prefix }],
			['referee.position', { prefix }],
			['referee.telephone', { prefix }],
			['referee.email', { prefix }],
		]);

		const renderField = (props) => <FieldGroup key={props.name} isEditing={isEditing} {...props} />;

		const label = `Previous position ${index+1}`;
		return (
			<React.Fragment key={index}>
				<h3>{label}</h3>
				{ remove &&
					<button type="button" className="btn btn-primary" onClick={() => remove(index)}>Remove</button>
				}

				{ positionDetailFields.map(renderField) }

				<p><b>Previous company address</b></p>
				{ companyAddressFields.map(renderField) }

				<p><b>Referee details</b></p>
				{ refereeFields.map(renderField) }
				
			</React.Fragment>
		)
	}
}

export default EmploymentHistoryField;


// WEBPACK FOOTER //
// ./src/modules/form/components/input/EmploymentHistory.jsx